import script from "./Mixlr.vue?vue&type=script&setup=true&lang=js"
export * from "./Mixlr.vue?vue&type=script&setup=true&lang=js"

import "./Mixlr.vue?vue&type=style&index=0&id=d120bcdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d120bcdc"]])

export default __exports__